
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass('Gamification.Gamification.ProdottiEsperienzeEditor')
    export class ProdottiEsperienzeEditor extends Serenity.Extensions.GridEditorBase<ProdottiEsperienzeRow, any> {
        protected getColumnsKey() { return ProdottiEsperienzeEditorColumns.columnsKey; }
        protected getDialogType() { return ProdottiEsperienzeEditorDialog; }
        protected getIdProperty() { return ProdottiEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: false,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 300
            });

            return this.slickGrid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            //opt.rowHeight = 150;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return (this.idProdotto > 0);
        }

        protected getColumns() {
            var columns = super.getColumns();

            //
            if (!Q.Authorization.hasPermission("Role:SuperAdmin")) {

                // Add column
                columns.unshift({
                    field: 'Delete Row',
                    name: '',
                    format: ctx => '<a class="inline-action delete-row" title="Elimina">' +
                        '<i class="fa fa-trash-o text-red"></i></a>',
                    width: 24,
                    minWidth: 24,
                    maxWidth: 24
                });

            }

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            }

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        this.view.deleteItem(item.IdProdottoEsperienza);
                    });
                }
            }
        }


        initDialog() {
            //var dialog = new ProdottiEsperienzeEditorDialog();
            //dialog.idProdotto = this.idProdotto;
        }

        /*
            Attenzione

            initEntityDialog() chiama initDialog()
            il parametro dialog di initEntityDialog() contiene l'istanza della dialog restituita da protected getDialogType()
            
        */
        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);

            dialog.idProdotto = this.idProdotto;

            //var theDialog: ProdottiEsperienzeEditorDialog = dialog;
            //theDialog.idProdotto = this.idProdotto;
        }

        validateEntity(row, id) {
            var entity = row as ProdottiEsperienzeRow;

            if (entity.EsperienzaClassiList.length > 0)
                entity.NumeroClassi = entity.EsperienzaClassiList.length;

            return true;
        }

        // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        private _idProdotto: number;

        get idProdotto() {
            return this._idProdotto;
        }

        set idProdotto(value: number) {
            if (this._idProdotto != value) {
                this._idProdotto = value;
            }
        }
    }
}